import { render } from "./SelectItemLang.vue?vue&type=template&id=43014871"
import script from "./SelectItemLang.vue?vue&type=script&lang=js"
export * from "./SelectItemLang.vue?vue&type=script&lang=js"

import "./SelectItemLang.vue?vue&type=style&index=0&id=43014871&lang=scss"

import exportComponent from "C:\\agent\\_work\\39\\s\\Infosit.Cms.Web.v2\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__